import { render, staticRenderFns } from "./BatteryFeatures.vue?vue&type=template&id=82b9250e"
import script from "./BatteryFeatures.vue?vue&type=script&lang=js"
export * from "./BatteryFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports